// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-29T08:28:26Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.eosp.controller.SpravaKontaktuController.
 */
export default class SpravaKontaktuApi {
    /**
     * 
     *
     * @param email 
     * @param kod 
     * @return 
     */
    static checkOvereniEmailKod(email, kod) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/check`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (email != null) {data.append("email", email);}
        if (kod != null) {data.append("kod", kod);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * 
     *
     * @param repeatRequestCode 
     * @return 
     */
    static repeatTelefon(repeatRequestCode) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/repeat`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (repeatRequestCode != null) {data.append("repeatRequestCode", repeatRequestCode);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * 
     *
     * @param telefon 
     * @return 
     */
    static getOvereniTelefonKod(telefon) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/get`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (telefon != null) {data.append("telefon", telefon);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * Změna emailu a telefonu na subjektu účtu.
     *
     * @param guid GUID účtu
     * @param data data formuláře
     */
    static updateKontakty(guid, data) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/ucty/${guid}/update`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, data, headers));
    }

    /**
     * 
     *
     * @param email 
     * @return 
     */
    static getOvereniEmailKod(email) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/get`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (email != null) {data.append("email", email);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * 
     *
     * @param repeatRequestCode 
     * @return 
     */
    static repeatEmail(repeatRequestCode) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/repeat`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (repeatRequestCode != null) {data.append("repeatRequestCode", repeatRequestCode);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

    /**
     * 
     *
     * @param telefon 
     * @param kod 
     * @return 
     */
    static checkOvereniTelefonKod(telefon, kod) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/check`;
        const headers = new Headers();
        headers.append("Content-Type", "multipart/form-data");
        const params = {  };
        const data = new FormData();
        if (telefon != null) {data.append("telefon", telefon);}
        if (kod != null) {data.append("kod", kod);}
 
        return ErrorApi.responseResolver(ParamsFetch.post(uri, params, data, headers));
    }

}
